import React, { useContext} from 'react';
import { Context } from '../../services/contexts/StateContext';
import load_B from '../../midia/load_B.gif';
// ------------------------------------------
export function Load_Bola(){
  const { state, dispatch } = useContext(Context);
  const { parametroInit } = state.parametros;
  const { loadBola } = parametroInit;


  return (
    <div style={
      {
        display: loadBola ? "flex" : "none",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: 'black',
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000
      }}>

      <img src={load_B} style={{display: "flex", width:"60px", height:"60px"}} alt="Carregando..." />
    </div>
  )
}